import React from 'react';
import fmt from 'utils/fmt';

export default function StatusBar(props) {
  const SHOP_INFO = props.currentShop;

  return (
    <div className="flex items-center border-b border-cust-line h-16 p-1 bg-cust-gray md:h-14 md:p-2">
      {/* 좌측: 메뉴 버튼 및 가게 이름 */}
      <div className="flex flex-row items-center flex-1 min-w-0">
        <button 
          className="w-10 h-10 p-2 flex items-center justify-center shrink-0 focus:outline-none md:w-12 md:h-12 md:p-3" 
          onClick={props.shopSelectBtnPressed}
          aria-label="Shop Select"
        >
          <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" className="w-6 h-6">
            <path d="M 3 7 A 1.0001 1.0001 0 1 0 3 9 L 27 9 A 1.0001 1.0001 0 1 0 27 7 L 3 7 z M 3 14 A 1.0001 1.0001 0 1 0 3 16 L 27 16 A 1.0001 1.0001 0 1 0 27 14 L 3 14 z M 3 21 A 1.0001 1.0001 0 1 0 3 23 L 27 23 A 1.0001 1.0001 0 1 0 27 21 L 3 21 z" />
          </svg>
        </button>
        <div className="flex flex-col min-w-0 ml-1.5 text-primary md:flex-row md:items-baseline md:ml-4 md:gap-2">
          <span className="font-medium text-xs text-gray-800 truncate md:text-base">{SHOP_INFO?.shopTitle || ''}</span>
          <div className="flex items-baseline gap-1 whitespace-nowrap">
            <span className="text-xs font-bold md:text-base">금일 <span className="hidden md:inline">매출현황 </span>{props.completedPaymentCount || 0}건</span>
            <span className="text-sm font-bold md:text-xl">{fmt.getCurrency(props.completedPaymentAmount || 0)}원</span>
          </div>
        </div>
      </div>

      <div className="flex items-center shrink-0 space-x-0.5 md:space-x-1">
        <button
          className="w-10 h-10 p-2 flex items-center justify-center focus:outline-none md:w-12 md:h-12 md:p-3"
          onClick={props.administratorBtnPressed}
          aria-label="Sales Management"
        >
          {/* 매출관리 (Bar Chart Icon) */}
          <svg className="w-6 h-6 fill-current text-gray-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
          </svg>
        </button>

        {/* 추가된 버튼: 메뉴 리스트 / 전체 보기 (Menu List Icon) */}
        <button 
          className="w-10 h-10 p-2 flex items-center justify-center focus:outline-none md:w-12 md:h-12 md:p-3" 
          onClick={props.menuListBtnPressed}
          aria-label="Menu List"
        >
          <svg 
            className="w-6 h-6 text-gray-800" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="m3 7 2 2 4-4" />
            <path d="m3 17 2 2 4-4" />
            <path d="M13 6h8" />
            <path d="M13 12h8" />
            <path d="M13 18h8" />
          </svg>
        </button>

        {/* 가운데 버튼: 개인설정 (User/Profile Icon) */}
        <button 
          className="w-10 h-10 p-2 flex items-center justify-center focus:outline-none md:w-12 md:h-12 md:p-3" 
          onClick={props.settingMyBtnPressed}
          aria-label="My Settings"
        >
          <svg className="w-6 h-6 fill-current text-gray-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
        </button>

        {/* 오른쪽 버튼: 프린터 (Printer Icon) */}
        <button 
          className="w-10 h-10 p-2 flex items-center justify-center focus:outline-none md:w-12 md:h-12 md:p-3" 
          onClick={props.settingBtnPressed}
          aria-label="Printer Settings"
        >
          <svg className="w-6 h-6 fill-current text-gray-800" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" />
          </svg>
        </button>
      </div>
    </div>
  );
}